import { createServiceManifest } from '@estee/elc-service';
import { SMARTGIFT } from '@estee/elc-service-view-names';
import { SmartgiftService } from './service-setup/SmartgiftService';

const { name, version } = __serviceInfo__;

const serviceViews = [SMARTGIFT];
const serviceEvents: string[] = [];
const serviceQueries: string[] = [];

export const ServiceManifest = createServiceManifest<SmartgiftService>(
    {
        views: serviceViews,
        events: serviceEvents,
        queries: serviceQueries,
        name,
        version
    },
    () =>
        import(
            /* webpackChunkName: 'core' */
            './service-setup/diContainer'
        ),
    'smartgiftService'
);
